import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Table } from 'react-bootstrap';
import { FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import AddSearchEquityForm from './AddSearchEquityForm';
import Chart from '../highcharts/Chart';
import { urls } from '../../services/Server';
import color from '../../config/color';

export default class SearchEquityModal extends Component {
  /*
    This component is showing info about a equity in a modal.
  */

  constructor(props) {
    super(props);

    // Initial state
    this.state = {
      show: false,
      chartLoaded: false,
      chart: []
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // Update the modal when new props arrive.
    const self = this;
    self.setState({ show: newProps.show });

    if (newProps.show) {
      self.loadChart(newProps.equity.type, newProps.equity.id);
    }
  }

  loadChart = (type, equityId) =>
    fetch(`${urls.equity}/${type}/${equityId}`, {
      credentials: 'include'
    }).then(async response => {
      if (response.status !== 500) {
        const json = await response.json();
        this.chartLoaded(json);
      }
    });

  chartLoaded = json => {
    this.setState({
      chartLoaded: true,
      chart: json
    });
  };

  hideModal = () => {
    this.props.hide();
    this.setState({ chartLoaded: false });
  };

  render() {
    let chartIfLoaded;
    const { equity } = this.props;

    if (this.state.chartLoaded && this.state.chart.length) {
      chartIfLoaded = (
        <Chart
          container="equity-chart"
          chartKey="equity"
          data={this.state.chart}
        />
      );
    }
    return equity ? (
      <Modal show={this.state.show} onHide={this.hideModal}>
        <Modal.Header closeButton>
          <Modal.Title>{equity.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table hover responsive size="sm">
            <tbody className="no-border">
              <tr>
                <td>ID</td>
                <td>{equity.id}</td>
              </tr>
              <tr>
                <td>Siste kurs</td>
                <td>
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    value={equity.price}
                  />
                </td>
              </tr>
              <tr>
                <td>Oppdatert</td>
                <td>
                  <FormattedDateTime
                    timestamp={equity.time}
                    type={equity.type}
                    showClockPrefix
                  />
                </td>
              </tr>
              <tr>
                <td>Siste dag</td>
                <td className={color.getClassName(equity.percent)}>
                  {equity.percent ? (
                    <FormattedNumber // eslint-disable-next-line
                      style="percent"
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                      value={equity.percent / 100}
                    />
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Body>
          <AddSearchEquityForm equityId={equity.id} />
        </Modal.Body>
        <Modal.Body>{chartIfLoaded}</Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={this.hideModal}>
            Lukk
          </Button>
        </Modal.Footer>
      </Modal>
    ) : null;
  }
}

SearchEquityModal.propTypes = {
  equity: PropTypes.objectOf(PropTypes.any),
  hide: PropTypes.func.isRequired
};
